/** Wszystkie kwoty w systemie są liczbami całkowitymi w groszach. */
export type Grosze = number;

export function assertGrosze(value: number, label = "kwota"): Grosze {
  if (!Number.isSafeInteger(value)) throw new Error(`${label} musi być liczbą całkowitą groszy, jest: ${value}`);
  return value;
}

export function formatPLN(grosze: Grosze): string {
  const sign = grosze < 0 ? "-" : "";
  const abs = Math.abs(grosze);
  const zl = Math.floor(abs / 100)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${sign}${zl},${String(abs % 100).padStart(2, "0")} zł`;
}

/**
 * Dzieli kwotę proporcjonalnie do wag metodą największych reszt —
 * suma części zawsze równa się `total` co do grosza.
 */
export function allocate(total: Grosze, weights: number[]): Grosze[] {
  if (weights.length === 0) return [];
  const sumW = weights.reduce((a, b) => a + b, 0);
  if (sumW <= 0) return weights.map(() => 0);
  const raw = weights.map((w) => (total * w) / sumW);
  const parts = raw.map((r) => Math.trunc(r));
  let rest = total - parts.reduce((a, b) => a + b, 0);
  const order = raw
    .map((r, i) => ({ i, frac: Math.abs(r - Math.trunc(r)) }))
    .sort((a, b) => b.frac - a.frac || a.i - b.i);
  const step = Math.sign(rest);
  for (let k = 0; rest !== 0; k = (k + 1) % order.length) {
    parts[order[k]!.i]! += step;
    rest -= step;
  }
  return parts;
}
